
import { Droplets, Building } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const ProductTabs = () => {
  return (
    <Tabs defaultValue="formulas" className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="formulas" className="flex items-center gap-2">
          <Droplets className="h-4 w-4" />
          Associated Formulas
        </TabsTrigger>
        <TabsTrigger value="facilities" className="flex items-center gap-2">
          <Building className="h-4 w-4" />
          Manufacturing Facilities
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="formulas" className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Droplets className="h-5 w-5" />
              Formulas
            </CardTitle>
            <CardDescription>
              Chemical formulations associated with this product
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-muted/50 p-8 rounded-lg border border-dashed text-center">
              <Droplets className="h-10 w-10 text-muted-foreground mx-auto mb-4" />
              <h3 className="text-lg font-medium mb-2">No Formulas Associated</h3>
              <p className="text-muted-foreground mb-4">
                This product doesn't have any formulas associated with it yet.
              </p>
              <Button variant="outline" disabled>
                Link Formula (Coming Soon)
              </Button>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="facilities" className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Building className="h-5 w-5" />
              Manufacturing Facilities
            </CardTitle>
            <CardDescription>
              Facilities where this product is manufactured
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-muted/50 p-8 rounded-lg border border-dashed text-center">
              <Building className="h-10 w-10 text-muted-foreground mx-auto mb-4" />
              <h3 className="text-lg font-medium mb-2">No Facilities Associated</h3>
              <p className="text-muted-foreground mb-4">
                This product doesn't have any manufacturing facilities associated with it yet.
              </p>
              <Button variant="outline" disabled>
                Link Facility (Coming Soon)
              </Button>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
    </Tabs>
  );
};
